import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ManualWarehousingService} from "../../manual-warehousing.service";
import {IModel} from "../../../../../shared/view-model/imodel.interface";
import {Stock} from "../../../../../shared/view-model/stock";
import {MedicineWithdrawalAuthFormComponent} from "../../../../../store-management/withdrawal/medicine-withdrawal-auth-form/medicine-withdrawal-auth-form.component";
import {BarcodeScannerComponent} from "../../../../../core/visbos-core/ui/components/barcode-scanner/barcode-scanner.component";
import {GenericModalComponent} from "../../../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {AbstractVisbosComponent} from "../../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../../shared/actions";
import {MessageType} from "../../../../../shared/redux-store/session";
import {WarehousingSupplierInterface} from "../../../../../store-management/model/warehousing-supplier-interface.type";
import {StockService} from "../../../../../store-management/services/stock.service";
import {map} from "rxjs/operators";
import {GERMAN_LAYOUT} from "../../../../../core/visbos-core/ui/directives/on-screen-keyboard.directive";
import {KeyboardOptions} from "virtual-keyboard";

@Component({
  selector: 'vb-manual-warehousing-articles',
  templateUrl: './manual-warehousing-articles.component.html',
  styleUrls: ['./manual-warehousing-articles.component.css']
})
export class ManualWarehousingArticlesComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  @ViewChild('addMedDataModal')
  addMedDataModal: GenericModalComponent;

  @ViewChild('medForm')
  medForm: MedicineWithdrawalAuthFormComponent;

  @ViewChild(BarcodeScannerComponent)
  barcodeComponent: BarcodeScannerComponent;

  allowedScanTypes = ['Stock', 'AdministrationUnit', 'Vehicle'];

  searchResultColumns = [
    {name: 'Bezeichner', prop: 'label'},
    {name: 'Lager', prop: 'depot.label'},
    {name: 'Lagerplatz', prop: 'depot_yard.label'},
  ];

  searchFunction = (term) => this.stockService.searchStocks(term)
    .pipe(map(({stocks}) => {
      let st = [...stocks];
      return st.sort((st1: Stock, st2: Stock) => st1.label.localeCompare(st2.label));
    }));

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              public warehousingService: ManualWarehousingService, private stockService: StockService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onScanned(scannedItem: IModel) {

    if (!scannedItem) {
      return;
    }

    if (scannedItem.__typename == 'Stock') {
      this.onStockScanned(scannedItem);
      return;
    }

    this.barcodeComponent.error("Der Barcode ist keinem Bestandsartikel zugeordnet!");

  }

  onStockScanned(stock: Stock) {
    this.warehousingService.addStock(stock);
    if (stock.registration_required) {
      this.provideMedicineWithdrawalData();
    }
  }

  stockManuallyAdded(stock: Stock) {
    this.onStockScanned(stock);
  }

  removeStock(stock: Stock) {
    this.warehousingService.removeStock(stock);
  }

  updateAmount(stock: Stock, amount: number) {
    this.warehousingService.updateStockAmount(stock, amount);
  }

  provideMedicineWithdrawalData() {
    if (this.warehousingService.needsAuthorization()) {
      this.addMedDataModal.show();
      this.barcodeComponent.enabled = false;
    }
  }

  medicineAuthDataProvided() {
    this.warehousingService.authorizeWarehousing();
    this.barcodeComponent.enabled = true;
  }

  medicineAuthCanceled() {
    this.sessionActions.pushMessage("Die Authorisierung wurde abgebrochen, der letzte gesannte Artikel wurde aus der List entfernt!", MessageType.WARNING, "Wareneingang");
    this.warehousingService.undoAddingStock();
    this.barcodeComponent.enabled = true;
  }

  onSupplierChanged(supplier: WarehousingSupplierInterface) {
    this.warehousingService.supplier = supplier;
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-warehousing/components/manual-warehousing-articles/manual-warehousing-articles.component.ts